import { Table } from 'antd';
import styled from 'styled-components';

import LinkButton from 'components/button/LinkButton';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';

interface userDataParams {
  userInfoData?: UserInfoTypes;
}

const UserInfo = ({ userInfoData }: userDataParams) => {
  const onClick = () => {
    let openUrl = window.location.origin.includes('metagymdev')
      ? 'https://metagymdev.exbody.com:60007'
      : window.location.origin.includes('.qa.')
      ? 'https://exbody.qa.metafamily.world/'
      : 'https://member.exbody.com';
    window.open(openUrl, 'childWindow', 'width=400');
  };

  const columns = [
    {
      dataIndex: 'userInfor',
      key: 'userInfor',
      width: '240px'
    },
    {
      dataIndex: 'contents',
      key: 'contents'
    }
  ];

  const dataSource = [
    {
      key: '1',
      userInfor: '이름*',
      contents: <div>{userInfoData?.usrname}</div>
    },
    {
      key: '2',
      userInfor: '생년월일*',
      contents: <div>{userInfoData?.usrbirth}</div>
    },
    {
      key: '3',
      userInfor: '휴대폰번호*',
      contents: <div>{userInfoData?.usrphoneno}</div>
    },
    {
      key: '4',
      userInfor: '성별*',
      contents: (
        <div>
          {userInfoData?.usrgender === 'MAN'
            ? '남성'
            : userInfoData?.usrgender === 'WOMAN'
            ? '여성'
            : ''}
        </div>
      )
    },
    {
      key: '5',
      userInfor: '이메일*',
      contents: <div>{userInfoData?.usrid}</div>
    },
    {
      key: '6',
      userInfor: '비밀번호*',
      contents: (
        <ButtonWrapper>
          <p>회원 페이지에서 수정 가능</p>
          <LinkButton label="통합회원 사이트 열기" onClick={onClick} />
        </ButtonWrapper>
      )
    },
    {
      key: '7',
      userInfor: '닉네임*',
      contents: <div>{userInfoData?.usrname}</div>
    },
    {
      key: '8',
      userInfor: '통합회원 가입일',
      contents: <div>{userInfoData?.usrjoindate}</div>
    },
    {
      key: '9',
      userInfor: '엑스바디 통합회원 탈퇴',
      contents: (
        <ButtonWrapper>
          <p>엑스바디 통합 회원 페이지에서 탈퇴가능</p>
          <LinkButton label="통합회원 사이트 열기" onClick={onClick} />
        </ButtonWrapper>
      )
    }
  ];

  return (
    <Wrapper>
      <Table
        dataSource={dataSource}
        bordered
        columns={columns}
        showHeader={false}
        pagination={false}
      />
    </Wrapper>
  );
};

export default UserInfo;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    ${font.caption1_regular};
    color: ${color.gray500};
  }
`;

const Wrapper = styled.div`
  .ant-table-wrapper table tbody tr td:last-of-type {
    color: ${color.black2};
  }
`;
